module.exports = {"pt-BR":{"real_estate_agency_candidates":{"new":null}}}